import React from 'react';
import MobileSection from 'components_library/organisms/Section/MobileSection';
import StoryList from 'components_library/templates/StoryList/StoryList';

const StoryListMobileWrapper = props => (
  <StoryList {...props} SectionWrapperComponent={MobileSection} />
);

export default StoryListMobileWrapper;
